import React from 'react';

import { Content, Text } from './styles';

const NotFoundBills = () => {
  return (
    <Content>
      <Text>Não se preocupe! No primeiro mês não tem conta.</Text>
      <Text>
        A primeira cobrança individualizada, em seu nome, será processada <b>em até 60 dias</b> depois
        do cadastro no portal.
      </Text>
    </Content>
  );
};

export default NotFoundBills;
